import { Camera } from './render/camera.ts';
import { CanvasRenderer } from './render/canvasRenderer.ts';
import { GameEngine } from './simulation/gameEngine.ts';
import { PointerController } from './input/pointerController.ts';
import { HudManager } from './ui/hudManager.ts';
import { PromoDirector } from './simulation/promoDirector.ts';

function initGame() {
  const canvas = document.getElementById('gameCanvas') as HTMLCanvasElement;
  if (!canvas) {
    console.error('Không tìm thấy element #gameCanvas');
    return;
  }

  // 1. Khởi tạo Camera
  const camera = new Camera();

  // 2. Khởi tạo Renderer
  const renderer = new CanvasRenderer(canvas, camera);

  // 3. Khởi tạo GameEngine (Simulation Loop)
  const engine = new GameEngine();

  // 4. Khởi tạo PointerController (Touch / Mouse input)
  const pointerController = new PointerController(canvas, camera, engine);

  // 5. Khởi tạo HUD Manager (UI DOM Overlays)
  const hud = new HudManager(engine, camera, renderer, pointerController);

  // 6. Khởi tạo PromoDirector (Quay Video Quảng Bá 9:16 dài 30s)
  const promoDirector = new PromoDirector(engine, camera, hud);
  (window as any).__promoDirector = promoDirector;

  // Xử lý Resize cửa sổ
  const handleResize = () => {
    renderer.resize();
  };
  window.addEventListener('resize', handleResize);
  handleResize();

  // Khởi đầu: Camera căn chuẩn tâm khu phố (0, 0) bao quát bán kính giới hạn 100m
  camera.resetZoom();

  // Kiểm tra nếu có tham số ?promo=true trong URL -> Tự động chạy chế độ quay promo
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('promo') === 'true') {
    console.log('[main.ts] Phát hiện tham số ?promo=true, bắt đầu chế độ quay tự động 30s!');
    setTimeout(() => {
      promoDirector.start();
    }, 600);
  }

  // 60FPS Game Loop
  function gameLoop() {
    engine.update();
    const state = engine.getState();

    // Camera mượt mà follow theo người chơi khi không chủ động pan/zoom bản đồ
    if (pointerController.shouldFollowPlayer()) {
      camera.follow(state.player.x, state.player.y, 0.08);
    }

    // Render Canvas
    renderer.render(state);

    // Cập nhật HUD DOM
    hud.update(state);

    requestAnimationFrame(gameLoop);
  }

  requestAnimationFrame(gameLoop);
}

// Khởi chạy khi DOM load xong
window.addEventListener('DOMContentLoaded', initGame);

